<div class="d-flex flex-column h-100">
  <div class="d-flex w-100 flex-column">
    <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3 bg-white">
      <h4 class="m-0 text-crm">
        {{
          channel_id ? ('update_your_channel' | translate) + ' ' + channel?.name : ('create_a_new_channel' | translate)
        }}
      </h4>
      @if (baseService.isMobile) {
        <app-button (onChangeClick)="onCloseSidebar()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
          <app-icon>close</app-icon>
        </app-button>
      }
    </div>
    <mat-divider class="w-100"></mat-divider>
  </div>

  @if (isLoader) {
    <div class="d-flex h-100 w-100 justify-content-center align-items-center">
      <app-loader size="small"></app-loader>
    </div>
  }

  @if (channelForm && !isLoader) {
    <div class="d-flex h-100 w-100 overflow-auto">
      <div class="d-flex w-100 h-100 flex-column p-3 gap-2" [formGroup]="channelForm">
        <div>
          <app-input
            [required]="true"
            [formControl]="channelForm.controls.name"
            label="{{ 'name_channel' | translate }}"
            placeholder="{{ 'enter_the_name_of_the' | translate }}"
          />
        </div>
        @if (!channel_id) {
          <div class="flex flex-col gap-1">
            <span class="text-xs font-medium text-gray-500">{{ 'type_channel' | translate }}</span>
            <button
              type="button"
              class="flex w-full min-w-0 items-center gap-2 rounded-lg! border bg-white px-3 py-2.5 text-left hover:bg-gray-50"
              [ngClass]="
                channelForm.controls.type.touched && channelForm.controls.type.invalid
                  ? 'border-red-400'
                  : 'border-gray-300'
              "
              (click)="openChannelTypesSidebar()"
            >
              @if (selectedChannelType) {
                @if (selectedChannelType.img) {
                  <img
                    [src]="selectedChannelType.img"
                    [alt]="selectedChannelType.name | translate"
                    class="h-6 w-6 shrink-0 object-contain"
                  />
                }
                <span class="min-w-0 flex-1 truncate text-sm font-medium text-gray-900">
                  {{ selectedChannelType.name | translate }}
                </span>
              } @else {
                <span class="min-w-0 flex-1 truncate text-sm text-gray-400">{{ 'select' | translate }}</span>
              }
              <app-icon class="shrink-0 text-gray-400">chevron_right</app-icon>
            </button>
          </div>
        }
        <div>
          <app-select
            label="name_funnel"
            [disabled]="!allowedFunnels?.length"
            class="w-100"
            optionLabel="name"
            optionValue="id"
            [isTranslate]="true"
            [options]="allowedFunnels"
            (valueChange)="getColumnsByFunnel($event)"
            [formControl]="channelForm.controls.funnel_id"
          />
        </div>
        <div>
          <app-select
            label="name_column"
            [disabled]="!allowedColumns?.length"
            class="w-100"
            optionLabel="name"
            optionValue="id"
            [isTranslate]="true"
            [options]="allowedColumns"
            [formControl]="channelForm.controls.column_id"
          />
        </div>
        @if ((canSelectDefaultResponsible || channel?.channel_group_id) && channelForm.controls.responsible_ids) {
          <app-select
            label="responsible_for_the_channel"
            [type]="SelectType.Multiple"
            class="w-100"
            [formControl]="channelForm.controls.responsible_ids"
            [options]="responsibleOptions"
            optionDisabled="disabled"
            optionLabel="name"
            optionValue="id"
            [isAvatar]="true"
            [disabled]="!!channel?.channel_group_id || responsibleLoading || responsibleLoadError"
            [loading]="responsibleLoading"
            [display]="channel?.channel_group_id ? 'comma' : 'chip'"
            [maxSelectedLabels]="managersList.length"
            [showToggleAll]="false"
            [showClear]="true"
            [filter]="true"
            [appendTo]="'body'"
          />
          @if (responsibleLoadError) {
            <div role="alert" class="flex items-center gap-2 text-sm text-red-600">
              <span>{{ 'chat_settings.group_error' | translate }}</span>
              <app-button btnType="no-border" (onChangeClick)="loadResponsibleEmployees()">
                {{ 'chat_settings.retry' | translate }}
              </app-button>
            </div>
          }
          @if (channel?.channel_group_id) {
            <div class="flex flex-wrap items-center gap-x-1 gap-y-0.5 text-xs text-slate-500">
              <span>{{ 'chat_settings.group_responsibility_hint' | translate }}</span>
              @if (canSelectDefaultResponsible) {
                <app-button
                  btnType="no-border"
                  customClass="!h-auto !min-w-0 !bg-transparent !p-0 !text-xs !text-blue-600 !tracking-normal underline"
                  [disabled]="openingGroup"
                  (onChangeClick)="openChannelGroup()"
                >
                  {{ 'chat_settings.edit_channel_group' | translate }}
                </app-button>
              }
            </div>
          }
        }
        @if (channel_type !== 'WIDGET') {
          <!-- <app-checkbox [disabled]="isDisabled" [formControl]="channelForm.controls.is_create_deal">
            {{ 'is_create_deal' | translate }}
          </app-checkbox> -->
          <app-checkbox [disabled]="isDisabled" [formControl]="channelForm.controls.is_read_message">
            {{ 'is_read_messages' | translate }}
          </app-checkbox>
          @if (channelForm.controls.is_notification_delivery) {
            <app-checkbox [formControl]="channelForm.controls.is_notification_delivery">
              {{ 'is_notification_delivery' | translate }}
            </app-checkbox>
          }
        }
      </div>
    </div>
  }

  <div class="d-flex w-100 flex-column">
    <mat-divider class="w-100"></mat-divider>
    <div class="bg-white d-flex justify-content-center align-items-center gap-2 p-4">
      <app-button [customClass]="'bg-danger'" (onChangeClick)="onCloseSidebar()">
        {{ 'cancel' | translate }}
      </app-button>
      <div class="flex-fill"></div>
      @if (!channel_id) {
        <app-button [disabled]="!channelForm || channelForm.invalid || responsibleLoading || responsibleLoadError" (onChangeClick)="onSave()">
          {{ 'save' | translate }}
        </app-button>
      }
      @if (channel_id) {
        <app-button [disabled]="!channelForm || channelForm.invalid || !isHasChange || responsibleLoading || responsibleLoadError" (onChangeClick)="onSaveChange()">
          {{ 'change' | translate }}
        </app-button>
      }
    </div>
  </div>
</div>
